//
//
//
//
//
//
//
//

import payPublic from '@/javascript/payPublic'
export default {
  name: 'share',
  props: {
    sharePage: Object,
    position: Object
  },
  data () {
    return {

    }
  },
  methods: {
    goShare () {
      payPublic.sharePage(this.sharePage)
    }
  }
}
